import { render } from "./Notifications.vue?vue&type=template&id=ce03eb72&scoped=true"
import script from "./Notifications.vue?vue&type=script&lang=js"
export * from "./Notifications.vue?vue&type=script&lang=js"

import "./Notifications.vue?vue&type=style&index=0&id=ce03eb72&lang=scss&scoped=true"

import exportComponent from "G:\\Programming\\VueProjects\\radinrealp2p\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce03eb72"]])

export default __exports__